module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/status-tag/status-tag.component.scss
// module id = ./src/app/modules/common-module/components/status-tag/status-tag.component.scss
// module chunks = 9